"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _CwImage = _interopRequireDefault(require("../../cwimage/CwImage"));

var _CwLabel = _interopRequireDefault(require("../../cwlabel/CwLabel"));

var _reactPopper = require("react-popper");

var _CwContextMenu = _interopRequireDefault(require("../CwContextMenu"));

var _CwContextMenu2 = _interopRequireDefault(require("../CwContextMenu.scss"));

var CwContextMenuItem = function CwContextMenuItem(props) {
  var _cx;

  var getOptionObject = function getOptionObject() {
    return {
      id: props.id,
      label: props.label,
      children: props.childOptions
    };
  }; // calculate label width


  var maxLabelWidth = props.childOptions.length > 0 ? 220 : 238;
  var labelWidth = props.label.length * 10;

  if (labelWidth > maxLabelWidth) {
    labelWidth = maxLabelWidth;
  }

  return _react.default.createElement(_reactPopper.Manager, {
    onMouseEnter: function onMouseEnter() {
      if (!props.disabled) {
        props.onMouseEnter(getOptionObject());
      }
    }
  }, _react.default.createElement(_reactPopper.Target, null, _react.default.createElement(_react.Fragment, null, _react.default.createElement("div", {
    "data-cwid": props.cwId,
    className: (0, _classnames.default)(_CwContextMenu2.default.contextMenuItem, (_cx = {}, (0, _defineProperty2.default)(_cx, _CwContextMenu2.default.active, props.isActive), (0, _defineProperty2.default)(_cx, _CwContextMenu2.default.disabled, props.disabled), _cx)),
    style: {
      paddingRight: props.childOptions.length > 0 ? 4 : 8
    },
    onClick: function onClick() {
      if (!props.disabled) {
        props.onClick(getOptionObject());
      }
    }
  }, _react.default.createElement(_CwLabel.default, {
    cwId: "".concat(props.cwId, "_label"),
    value: props.label,
    style: {
      width: labelWidth
    }
  }), props.childOptions.length > 0 && _react.default.createElement("div", {
    "data-cwid": "".concat(props.cwId, "_icon"),
    className: _CwContextMenu2.default.itemArrow
  }, _react.default.createElement(_CwImage.default, {
    src: props.expandIcon
  }))), props.seperator && _react.default.createElement("div", {
    className: _CwContextMenu2.default.seperator
  }))), props.childOptions.length > 0 && props.isActive && _react.default.createElement(_reactPopper.Popper, {
    placement: "right-start"
  }, _react.default.createElement(_CwContextMenu.default, {
    cwId: "".concat(props.cwId, "_context"),
    expandIcon: props.expandIcon,
    scrollIconDown: props.scrollIconDown,
    scrollIconUp: props.scrollIconUp,
    options: props.childOptions,
    onOptionClick: props.onClick,
    isSubContextMenu: true
  })));
};

CwContextMenuItem.propTypes = {
  cwId: _propTypes.default.string.isRequired,
  id: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired,
  isActive: _propTypes.default.bool.isRequired,
  childOptions: _propTypes.default.array,
  disabled: _propTypes.default.bool,
  expandIcon: _propTypes.default.string,
  scrollIconDown: _propTypes.default.string,
  scrollIconUp: _propTypes.default.string,
  label: _propTypes.default.string,
  seperator: _propTypes.default.bool,
  onMouseEnter: _propTypes.default.func.isRequired,
  onClick: _propTypes.default.func.isRequired
};
CwContextMenuItem.defaultProps = {
  childOptions: [],
  disabled: false,
  expandIcon: '',
  scrollIconDown: '',
  scrollIconUp: '',
  label: '--',
  seperator: false
};
var _default = CwContextMenuItem;
exports.default = _default;